import React, { useState, useEffect } from "react";
import { useParams } from "react-router";
import { useComponentTranslation } from "@/services/i18n";
import { FaToggleOn, FaToggleOff } from "react-icons/fa";
import toast from "react-hot-toast";
import API from "@/services/api";

const translations = {
  en: {
    publish: "Publish",
    unpublish: "Unpublish",
    post_published: "Post published successfully",
    post_unpublished: "Post unpublished successfully",
    post_not_enabled: "Failed to publish post",
  },
  fr: {
    publish: "Publier",
    unpublish: "Dépublier",
    post_published: "Publication publiée avec succès",
    post_unpublished: "Publication dépubliée avec succès",
    post_not_enabled: "Échec de la publication",
  },
};

export default function PublishToggle({ job, channel, posts = [], setPosts }) {
  const { t } = useComponentTranslation(translations);
  const { id: jobId } = useParams();
  const [isToggling, setIsToggling] = useState(false);

  // Find job post from posts array
  const jobPost = channel ? posts.find(post => post.channel_id === channel._id) : null;

  const handleTogglePost = async () => {
    try {
      setIsToggling(true);

      if (jobPost?._id) {
        // Delete existing post (unpublish)
        const response = await API.remove(`/post/${jobPost._id}`);
        if (response.ok) {
          toast.success(t("post_unpublished"));
          // Remove from posts array
          if (setPosts) {
            setPosts(prev => prev.filter(p => p._id !== jobPost._id));
          }
        } else {
          toast.error(response.code || "Error unpublishing post");
        }
      } else {
        // Create new post (publish)
        const response = await API.post(`/post`, {
          job_id: jobId,
          channel_id: channel._id,
        });
        if (response.ok) {
          toast.success(t("post_published"));
          // Add to posts array
          if (setPosts) {
            setPosts(prev => [...prev, response.data]);
          }
        } else {
          toast.error(t("post_not_enabled"));
        }
      }
    } catch (e) {
      console.error("Error toggling post:", e);
      toast.error(e.code);
    } finally {
      setIsToggling(false);
    }
  };

  const isPublished = !!jobPost?._id;

  return (
    <button
      onClick={handleTogglePost}
      disabled={isToggling}
      className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
        isPublished
          ? "bg-green-50 text-green-700 border border-green-200 hover:bg-green-100"
          : "bg-gray-100 text-gray-700 border border-gray-200 hover:bg-gray-200"
      } ${isToggling ? "opacity-50 cursor-not-allowed" : ""}`}
    >
      {isPublished ? (
        <>
          <FaToggleOn className="w-5 h-5 text-green-600" />
          {t("unpublish")}
        </>
      ) : (
        <>
          <FaToggleOff className="w-5 h-5" />
          {t("publish")}
        </>
      )}
    </button>
  );
}


